/**
 * Floating button component
 */

import { DomUtils } from '../../utils/DomUtils.js';

export class FloatingButton {
  constructor(options = {}, eventBus) {
    this.options = options;
    this.eventBus = eventBus;
    this.element = null;
    this.isVisible = true;
  }

  /**
   * Create the floating button element
   */
  create() {
    this.element = DomUtils.createElement('div', 'flowlight-button', {
      position: 'fixed',
      width: `${this.options.buttonSize}px`,
      height: `${this.options.buttonSize}px`,
      bottom: `${this.options.buttonPosition.bottom}px`,
      right: `${this.options.buttonPosition.right}px`,
      backgroundColor: '#000000',
      borderRadius: '50%',
      border: 'none',
      cursor: 'pointer',
      zIndex: this.options.zIndex,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
      transition: 'all 0.3s ease',
      userSelect: 'none'
    }, this.getButtonIcon());

    this.bindEvents();
    return this.element;
  }

  /**
   * Get the button icon SVG
   * @returns {string} - SVG icon HTML
   */
  getButtonIcon() {
    return `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }

  /**
   * Bind event listeners
   */
  bindEvents() {
    if (!this.element) return;

    // Hover effects
    this.element.addEventListener('mouseenter', () => {
      this.element.style.transform = 'scale(1.1)';
      this.element.style.boxShadow = '0 6px 25px rgba(0, 0, 0, 0.4)';
    });

    this.element.addEventListener('mouseleave', () => {
      this.element.style.transform = 'scale(1)';
      this.element.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.3)';
    });

    // Click handler
    this.element.addEventListener('click', () => {
      console.log('button clicked');
      this.eventBus.emit('button:click');
    });
  }

  /**
   * Render the button
   */
  render() {
    if (!this.element) {
      this.create();
    }
    
    if (this.isVisible) {
      document.body.appendChild(this.element);
    }
  }

  /**
   * Show the button
   */
  show() {
    if (this.element && !this.isVisible) {
      this.element.style.display = 'flex';
      this.isVisible = true;
    }
  }

  /**
   * Hide the button
   */
  hide() {
    if (this.element && this.isVisible) {
      this.element.style.display = 'none';
      this.isVisible = false;
    }
  }

  /**
   * Toggle button visibility
   */
  toggle() {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  /**
   * Update button position
   * @param {Object} position - New position { bottom, right }
   */
  updatePosition(position) {
    if (this.element) {
      this.element.style.bottom = `${position.bottom}px`;
      this.element.style.right = `${position.right}px`;
    }
  }

  /**
   * Update button size
   * @param {number} size - New size in pixels
   */
  updateSize(size) {
    if (this.element) {
      this.element.style.width = `${size}px`;
      this.element.style.height = `${size}px`;
    }
  }

  /**
   * Destroy the button
   */
  destroy() {
    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
    this.element = null;
  }
} 